// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3yk0-","footer":"ModalCreateQualiphyProcedure_footer__11ICU","additionData":"ModalCreateQualiphyProcedure_additionData__mv8-D"};